import styled from "styled-components";

export const StyledTable = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid #e2e8f0;
  border-radius: 0.875rem;
  background: #ffffff;
  box-shadow: 0 4px 14px rgb(15 23 42 / 0.06);

  & table {
    width: max-content;
    min-width: 100%;
    table-layout: auto;
    border-collapse: separate;
    border-spacing: 0;
  }

  & thead > tr > th {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #0f172a;
    color: #f8fafc;
    font-size: 0.8125rem;
    font-weight: 700;
    letter-spacing: 0.01em;
    border-bottom: 1px solid #334155;
    padding: 0.75rem 1rem;
    text-align: left;
    white-space: nowrap;
  }

  & td {
    border-bottom: 1px solid #e2e8f0;
    padding: 0.625rem 0.75rem;
    color: #334155;
    font-size: 0.8125rem;
    white-space: nowrap;
    overflow-wrap: normal;
    word-break: normal;
  }

  & table > thead > tr > th:nth-child(2),
  & table > tbody > tr > td:nth-child(2) {
    min-width: 27rem;
    white-space: normal;
    overflow-wrap: normal;
    word-break: normal;
  }

  & tbody tr:nth-child(even) {
    background-color: #f8fafc;
  }

  & tbody tr:hover {
    background-color: #ecfdf5;
  }

  & tfoot > tr > th {
    &:first-child {
      text-align: center;
    }

    background-color: #ecfdf5;
    border-top: 2px solid #6ee7b7;
    padding: 0.75rem;
    color: #0f172a;
    font-size: 0.8125rem;
    white-space: nowrap;
    overflow-wrap: normal;
    word-break: normal;
    text-align: right;
  }

  @media (max-width: 640px) {
    & thead > tr > th {
      padding: 0.625rem 0.75rem;
    }

    & td {
      padding: 0.5rem 0.625rem;
    }
  }
`;
